// Compact circular progress ring for the navbar AI-processing button. A minimal
// inline SVG sized + coloured via semantic tokens, with the clamped % centered
// inside. Hides at 100% (handled by the caller — the "to review" badge then
// carries the finished jobs).
const RING_SIZE = 22;
const RING_STROKE = 3;
const RING_RADIUS = (RING_SIZE - RING_STROKE) / 2;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

interface AiProcessingRingProps {
  percentage: number;
}

export function AiProcessingRing({ percentage }: AiProcessingRingProps) {
  const clamped = Math.min(100, Math.max(0, percentage));
  const dashOffset = RING_CIRCUMFERENCE * (1 - clamped / 100);

  return (
    <span className='relative inline-flex items-center justify-center'>
      <svg
        width={RING_SIZE}
        height={RING_SIZE}
        viewBox={`0 0 ${RING_SIZE} ${RING_SIZE}`}
        className='-rotate-90'
        aria-hidden='true'
      >
        <circle
          cx={RING_SIZE / 2}
          cy={RING_SIZE / 2}
          r={RING_RADIUS}
          fill='none'
          strokeWidth={RING_STROKE}
          strokeOpacity={0.2}
          className='stroke-current'
        />
        <circle
          cx={RING_SIZE / 2}
          cy={RING_SIZE / 2}
          r={RING_RADIUS}
          fill='none'
          strokeWidth={RING_STROKE}
          strokeLinecap='round'
          strokeDasharray={RING_CIRCUMFERENCE}
          strokeDashoffset={dashOffset}
          className='stroke-current transition-[stroke-dashoffset] duration-300 ease-linear'
        />
      </svg>
      <span className='absolute text-[7px] font-semibold leading-none tabular-nums'>
        {clamped}
      </span>
    </span>
  );
}
